<app-template-time [disabled]="disabled" [value]="value" [control]="control" [required]="required" [label]="label" />
